<template>
  <div :class="$style.csrBanner">
    <ImageWithAspectRatio
      :ratio="{ v: 1, h: 3 }"
      class="text-light"
    >
      <template v-slot:item="{ itemClass }">
        <img
          :class="[itemClass, $style.image]"
          :src="BACKGROUND_IMAGE"
        >
      </template>
    </ImageWithAspectRatio>

    <PageSection class="">
      <PageContainer>
        <CsrBannerContent />
      </PageContainer>
    </PageSection>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ImageWithAspectRatio from '@/scripts/pages/onepager/components/ImageWithAspectRatio.ts.vue';
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import CsrBannerContent from '../components/CsrBannerContent.ts.vue';
import { BACKGROUND_IMAGE } from '../assets/media';

export default Vue.extend({
  components: {
    ImageWithAspectRatio,
    CsrBannerContent,
    PageSection,
    PageContainer,
  },
  data() {
    return {
      BACKGROUND_IMAGE,
    };
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.image {
  object-fit: cover;
  object-position: center center;
}

.csrBanner {
  font-size: 1.12500rem;
}
</style>
